export enum DayCheckMode {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
